import DOMPurify, { type UponSanitizeElementHookEvent } from "dompurify";

const EDUCATIONAL_VIDEO_HOSTS = new Set([
  "www.youtube.com",
  "youtube.com",
  "www.youtube-nocookie.com",
  "youtube-nocookie.com",
  "player.vimeo.com",
  "www.loom.com",
  "loom.com",
  "www.useloom.com",
  "useloom.com",
  "fast.wistia.net",
  "fast.wistia.com",
  "www.wistia.com",
  "wistia.com",
]);

const EDUCATIONAL_HTML_POLICY = {
  ADD_TAGS: ["iframe"],
  ADD_ATTR: [
    "allow",
    "allowfullscreen",
    "frameborder",
    "height",
    "loading",
    "referrerpolicy",
    "sandbox",
    "scrolling",
    "src",
    "title",
    "width",
  ],
};

function isAllowedEducationalVideoSrc(value: string): boolean {
  try {
    const url = new URL(value, "https://unused.invalid");
    return url.protocol === "https:" && EDUCATIONAL_VIDEO_HOSTS.has(url.hostname.toLowerCase());
  } catch {
    return false;
  }
}

function keepAllowedEducationalIframes(currentNode: Node, hookEvent: UponSanitizeElementHookEvent) {
  if (hookEvent.tagName !== "iframe" || !(currentNode instanceof Element)) {
    return;
  }
  const src = currentNode.getAttribute("src") || "";
  if (!isAllowedEducationalVideoSrc(src)) {
    currentNode.remove();
  }
}

export function sanitizeEducationalHtml(value: unknown): string {
  DOMPurify.addHook("uponSanitizeElement", keepAllowedEducationalIframes);
  try {
    return DOMPurify.sanitize(typeof value === "string" ? value : "", EDUCATIONAL_HTML_POLICY);
  } finally {
    DOMPurify.removeHook("uponSanitizeElement", keepAllowedEducationalIframes);
  }
}
